import React, { useEffect, useState } from "react";
import {
  Modal,
  Tabs,
  Form,
  Input,
  Button,
  Radio,
  Select,
  Cascader,
  DatePicker,
  InputNumber,
  TreeSelect,
  Switch,
  Checkbox,
  Upload,
  Typography,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import {
  openNotification,
  swalNotification,
} from "../../../alret/notificztion";
import { useNavigate } from "react-router-dom";
import { validationErrors } from "../../../../utils/Helpers";
import { riderEdit } from "../../../../services/riders.service";
import moment from "moment";

const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

const normFile = (e) => {

  if (Array.isArray(e)) {
    return e;
  }

  return e && e.fileList;
};

const onChange = (date, dateString) => {
  // console.log(date, dateString);
};

const RiderEditModal = (props) => {
  const navigate = useNavigate();
  const [riderId, setRiderId] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);
  const [activeKey, setActiveKey] = React.useState("1");

  const onKeyChange = (key) => setActiveKey(key);

  useEffect(() => {
    setRiderId(props.RiderId);
  }, [props.RiderId]);

  const handleEditOk = async () => {
    props.setRiderEditOpenModal(false);
  };

  const handleCancel = () => {
    props.setRiderEditOpenModal(false);
  };

  const s3ImageUpload = async (file) => {
    // console.log("file object ", file);
    const target = { Bucket: "k2-products", Key: file.name, Body: file };
    const creds = {
      accesKeyId: "AKIA5L6BGAWSTQFXRNPO",
      secretKeyAccess: "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",
    };
    try {
      // const parallelUploadS3 = new UploadS3({
      //   client: new S3Client({region:"ap-southeast-1", credentials:creds}),
      //   leavePartsOnError: false,
      //   params: target
      // })
      const parallelUploads3 = new Upload({
        // client: new S3Client({ region: "ap-southeast-1", credentials: creds }),
        // tags: [...], // optional tags
        queueSize: 4, // optional concurrency configuration
        leavePartsOnError: false, // optional manually handle dropped parts
        params: target,
      });
      // console.log("parallelUploads3 => ", parallelUploads3);

      parallelUploads3.on("httpUploadProgress", (progress) => {
        // console.log("progess => ", progress);
      });

      await parallelUploads3.done();
    } catch (e) {
      // console.log('Errrr => ',Object.keys(e))
      // console.log("Errrr => ", e);
    }
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Failed:", errorInfo);
    // errorInfo.errorFields.map((v,i) => {
    //   console.log("errors ", v);
    // })
    if (errorInfo.errorFields.length > 0) {
      setActiveKey("1");
    }
  };

  const onFinish = async (values) => {
    // s3ImageUpload(values.profileimage[0].originFileObj);
    // console.log("profile image ", values.profileimage);
    // console.log("values ", values);
    // console.log("rider id ", riderId);
    // return null;
    values.dob =
      values.dateofbirth != ""
        ? moment(values.dateofbirth._d).format("MM-DD-yyyy")
        : "";
    values.cnic_issue_date =
      values.cnicissuedate != "" && values.cnicissuedate != undefined 
        ? moment(values.cnicissuedate._d).format("YYYY-MM-DDThh:mm:ss.mmmZ")
        : "";
    values.equipment.hand_over_date =
      values.equipment.handoverdate != ""
        ? moment(values.equipment.handoverdate._d).format(
            "YYYY-MM-DDThh:mm:ss.mmmZ"
          )
        : "";
    values.equipment.returning_date =
      values.equipment.returningdate != ""
        ? moment(values.equipment.returningdate._d).format(
            "YYYY-MM-DDThh:mm:ss.mmmZ"
          )
        : "";
    // if (values.profileimage !== undefined) {
    //   values.profileImage = values.profileimage[0].originFileObj;
    // } else {
    //   if (props.riderData.profileImage === null) {
    //     // openNotification(
    //     //   "Validation Error",
    //     //   "Profile Image is Required",
    //     //   "error"
    //     // );
    //     // swalNotification(
    //     //   "Validation Error",
    //     //   "Profile Image is Required",
    //     //   "error"
    //     // );
    //     // return null;
    //   } else {
    //     // values.profileImage = props.riderData.profileImage;
    //   }
    // }
    // if (values.billfront !== undefined) {
    //   values.bill = values.billfront[0].originFileObj;
    // } else {
    //   if (props.riderData.bill === null) {
    //     swalNotification("Validation Error", "Bill Image is Required", "error");
    //     return null;
    //   } else {
    //     values.bill = props.riderData.bill;
    //   }
    // }
    if (values.cnicfront !== undefined) {
      values.cnicFront = values.cnicfront[0].originFileObj;
    } else {
      if (props.riderData.cnicFront === null) {
        // swalNotification(
        //   "Validation Error",
        //   "CNIC Front Image is Required",
        //   "error"
        // );
        // return null;
      } else {
        // values.cnicFront = props.riderData.cnicFront;
      }
    }
    if (values.cnicback !== undefined) {
      values.cnicBack = values.cnicback[0].originFileObj;
    } else {
      if (props.riderData.cnicBack === null) {
        // swalNotification(
        //   "Validation Error",
        //   "CNIC Back Image is Required",
        //   "error"
        // );
        // return null;
      } else {
        // values.cnicBack = props.riderData.cnicBack;
      }
    }
    if (values.licensefront !== undefined) {
      values.licenseFront = values.licensefront[0].originFileObj;
    } else {
      if (props.riderData.licenseFront === null) {
        // swalNotification(
        //   "Validation Error",
        //   "License Front Image is Required",
        //   "error"
        // );
        // return null;
      } else {
        // values.licenseFront = props.riderData.licenseFront;
      }
    }
    if (values.licenseback !== undefined) {
      values.licenseBack = values.licenseback[0].originFileObj;
    } else {
      if (props.riderData.licenseBack === null) {
        // swalNotification(
        //   "Validation Error",
        //   "Licesne Back Image is Required",
        //   "error"
        // );
        // return null;
      } else {
        // values.licenseBack = props.riderData.licenseBack;
      }
    }

    if (values.billfront !== undefined) {
      values.bill = values.billfront[0].originFileObj;
    } else {
      if (props.riderData.bill === null) {
        // swalNotification("Validation Error", "Bill Image is Required", "error");
        // return null;
      } else {
        // values.bill = props.riderData.bill;
      }
    }
    if (values.status !== undefined) {
      values.status = values.status;
    } else {
      values.status = props.riderData.status;
    }

    if (values.payment.atm_status == undefined) {
      values.payment.atm_status = false;
    } 
    if (values.equipment.shirt_status == undefined) {
      values.equipment.shirt_status = false;
    }
    delete values["dateofbirth"];
    delete values["cnicissuedate"];
    delete values["equipment"]["handoverdate"];
    delete values["equipment"]["returningdate"];
    delete values["billfront"];
    delete values["cnicback"];
    delete values["cnicfront"];
    delete values["licenseback"];
    delete values["licensefront"];
    delete values["profileimage"];
    // console.log("after submit", values);
    // return null;

    // console.log("Received values of form: ", values);
    // return null;

    // var form_data = new FormData();
    // const keys = Object.keys(values);
    // const objValues = Object.values(values);
    // keys.map((key, idx) => {
    //   console.log(key, objValues[idx]);
    //   form_data.append([key], objValues[idx]);
    // });

    // for (var key of form_data.entries()) {
    //   console.log("formData key => ", key[0] + ", " + key[1]);
    // }
    // console.log("form data", form_data.entries());

    // console.log("keys", keys);
    // console.log("values", objValues);

    // let data = [];
    // keys.map((key, idx) => {
    //   console.log(key, objValues[idx]);
    //   form_data.append('name', 'ABC');
    //   // form_data.append([key], objValues[idx]);
    // });
    // console.log("form_data =>>>>>> ", form_data);

    const headers = {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      UserId: parseInt(localStorage.getItem("user_id")),
    };

    try {
      setMBtnLoading(true);
      const resp = await riderEdit(riderId, values, headers);
      // console.log("rider added", resp.data);
      if (resp.data.code == 200) {
        swalNotification("Rider Updated", resp.data.message, "success");
        navigate("/rider");
      }
    } catch (error) {
      validationErrors(error);
    } finally {
      // setIsDisabled(true);
      setMBtnLoading(false);
    }
  };

  const [state, setState] = useState({
    loading: false,
  });

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const handleChange = (info) => {
    let fileList = [...info.fileList];

    if (info.file.status === "uploading") {
      setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      // console.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      // console.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }

  const uploadProfileImageButton = (
    <div>
      <div className="ant-upload-text">Upload Profile Image</div>
    </div>
  );

  const uploadFrontCNICButton = (
    <div>
      <div className="ant-upload-text">Upload Front CNIC</div>
    </div>
  );

  const uploadBackCNICButton = (
    <div>
      <div className="ant-upload-text">Upload Back CNIC</div>
    </div>
  );

  const uploadFrontLicenseButton = (
    <div>
      <div className="ant-upload-text">Upload Front License</div>
    </div>
  );

  const uploadBackLicenseButton = (
    <div>
      <div className="ant-upload-text">Upload Back License</div>
    </div>
  );

  const uploadFrontBillButton = (
    <div>
      <div className="ant-upload-text">Upload Front Bill</div>
    </div>
  );

  const { imageUrl } = state;

  // useEffect(() => {
  //   if (props.riderData) {
  //     form.setFieldsValue(props.riderData);
  //   }
  // }, [props.riderData]);
  // const [form] = Form.useForm();

  return (
    <Modal
      visible={props.riderEditOpenModal}
      onOk={handleEditOk}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          form="myForm"
          key="submit"
          htmlType="submit"
          loading={MBtnLoading}
        >
          Submit
        </Button>,
      ]}
      style={{
        top: 20,
      }}
      // width={800}
    >
      {/* {console.log("before form open", props.riderData)} */}
      {props.riderData && props.riderData.id === riderId && (
        <Form
          // form={form}
          id="myForm"
          layout="vertical"
          initialValues={props.riderData}
          onFinishFailed={onFinishFailed}
          onFinish={onFinish}
        >
          <Tabs
            defaultActiveKey="1"
            activeKey={activeKey}
            onChange={onKeyChange}
          >
            <Tabs.TabPane tab="General" key="1">
              <div className="reSection">
                {/* <Title level={5}>{props.riderData.display_id}</Title> */}
                <Title level={5}>Personal</Title>
                <Form.Item
                  name={"fullName"}
                  label="Name"
                  rules={[
                    {
                      required: true,
                      message: "Rider Name is Required",
                    },
                  ]}
                >
                  <Input placeholder="Rider Name" />
                </Form.Item>
                <Form.Item
                  name={"phoneNumber"}
                  label="Phone Number"
                  rules={[
                    {
                      required: true,
                      message: "Phone Number is Required",
                    },
                  ]}
                >
                  <Input placeholder="Phone Number" />
                </Form.Item>
                <Form.Item
                  name={"email"}
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Email is Required",
                    },
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
                <Form.Item
                  name={"cnic"}
                  label="CNIC"
                  rules={[
                    {
                      required: true,
                      message: "CNIC number is Required",
                    },
                  ]}
                >
                  <Input placeholder="CNIC" />
                </Form.Item>

                <div className="reSection">
                  <Title level={5}>Address</Title>
                  <Form.Item
                    name={"city"}
                    label="City"
                    rules={[
                      {
                        required: true,
                        message: "City is Required",
                      },
                    ]}
                  >
                    <Select name={"city"} placeholder="Select City">
                      <Option value="" disabled>
                        Select City
                      </Option>
                      <Option value="Karachi">Karachi</Option>
                      <Option value="Lahore">Lahore</Option>
                      <Option value="Rawalpindi">Rawalpindi</Option>
                    </Select>
                  </Form.Item>
                 
                </div>
                
                <Form.Item
                  name={"dateofbirth"}
                  label="Date of birth"
                  initialValue={
                    props.riderData.dob === null
                      ? ""
                      : moment(props.riderData.dob)
                  }
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Date of birth is Required",
                  //   },
                  // ]}
                >
                  <DatePicker
                    format="YYYY-MM-DD"
                    onChange={onChange}
                    placeholder="Date of birth"
                    // defaultValue={props.riderData.dob != "" ? moment(props.riderData.dob) : ""}
                  />
                </Form.Item>
                
                <Form.Item
                  name="cnicissuedate"
                  label="CNIC issue date"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "CNIC issue date is Required",
                  //   },
                  // ]}
                  initialValue={
                    props.riderData.cnic_issue_date === null
                      ? ""
                      : moment(props.riderData.cnic_issue_date)
                  }
                >
                  <DatePicker
                    // showTime
                    placeholder="CNIC Issue Data"
                    format="YYYY-MM-DD"
                    onChange={onChange}
                    // defaultValue={moment(props.riderData.cnic_issue_date)}
                  />
                </Form.Item>
                <Form.Item
                  name={"marital_status"}
                  label="Marital Status"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Marital Status is Required",
                  //   },
                  // ]}
                >
                  <Select placeholder="Marital Status">
                    <Option value="Single">Single</Option>
                    <Option value="Married">Married</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["next_of_kin", "name"]}
                  label="Next of kin (Name)"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Next of kin name is Required",
                  //   },
                  // ]}
                >
                  <Input placeholder="Next of kin name" />
                </Form.Item>
                <Form.Item
                  name={["next_of_kin", "relation"]}
                  label="Next of kin (Relation)"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Next of kin relation is Required",
                  //   },
                  // ]}
                >
                  <Input placeholder="Next of kin Relation" />
                </Form.Item>
                <Form.Item
                  name={["next_of_kin", "number"]}
                  label="Next of kin (Phone Number)"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Next of kin number is Required",
                  //   },
                  // ]}
                >
                  <Input placeholder="Next of kin Number" />
                </Form.Item>
                <Form.Item
                  name={["next_of_kin", "cnic"]}
                  label="Next of kin (CNIC)"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Next of kin CNIC is Required",
                  //   },
                  // ]}
                >
                  <Input placeholder="Next of kin CNIC" />
                </Form.Item>
              </div>
              <div className="reSection">
                <Title level={5}>Payment</Title>
                <Form.Item name={["payment", "jazz_cash"]} label="Jazz Cash">
                  <Input placeholder="Jazz cash" />
                </Form.Item>
                <Form.Item name={["payment", "easy_paisa"]} label="Easypaisa">
                  <Input placeholder="Easy paisa" />
                </Form.Item>
                <Form.Item name={["payment", "hbl"]} label="HBL">
                  <Input placeholder="HBL Connect" />
                </Form.Item>
                <Form.Item
                  name={["payment", "bank_account"]}
                  label="Bank Account"
                >
                  <Input placeholder="Bank Account#" />
                </Form.Item>
                <Form.Item name={["payment", "atm_status"]} label="ATM Status">
                  <Select placeholder="ATM Status">
                    <Option value={true}>Active</Option>
                    <Option value={false}>Blocked</Option>
                  </Select>
                </Form.Item>
              </div>
              <div className="reSection">
                <Title level={5}>Equipment</Title>
                <Form.Item
                  name={["equipment", "handoverdate"]}
                  label="Hand over date"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Hand over date is Required",
                  //   },
                  // ]}
                  initialValue={
                    props.riderData.equipment.hand_over_date === null
                      ? ""
                      : moment(props.riderData.equipment.hand_over_date)
                  }
                >
                  <DatePicker
                    // showTime
                    placeholder="Hand over date"
                    format="YYYY-MM-DD"
                    onChange={onChange}
                  />
                </Form.Item>
                <Form.Item
                  name={["equipment", "returningdate"]}
                  label="Returning Date"
                  initialValue={
                    props.riderData.equipment.returning_date === null
                      ? ""
                      : moment(props.riderData.equipment.returning_date)
                  }
                >
                  <DatePicker
                    // showTime
                    placeholder="Returning date"
                    format="YYYY-MM-DD"
                    onChange={onChange}
                  />
                </Form.Item>
                <Form.Item
                  name={["equipment", "delivery_bag"]}
                  label="Delivery Bag"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Delivery Bag is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="Delivery bag" />
                </Form.Item>
                <Form.Item
                  name={["equipment", "t_shirt_count"]}
                  label="T-shirt count"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "T-shirt count is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="T-shirt count" min={0} />
                </Form.Item>
                <Form.Item
                  name={["equipment", "rain_coats"]}
                  label="Rain Coats"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Rain coats is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="Rain Coats" />
                </Form.Item>
                <Form.Item
                  name={["equipment", "rain_jackets"]}
                  label="Rain Jackets"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Rain Jackets is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="Rain Jackets" />
                </Form.Item>
                <Form.Item
                  name={["equipment", "caps"]}
                  label="Caps"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Cpas is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="Caps" />
                </Form.Item>
                <Form.Item
                  name={["equipment", "shirt_status"]}
                  label="Shirt Status"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Shirt status is Required",
                  //   },
                  // ]}
                >
                  <Select
                    placeholder="Shirt status"
                    // rules={[
                    //   {
                    //     required: true,
                    //     message: "Shirt status is Required",
                    //   },
                    // ]}
                  >
                    <Option value="true">Yes</Option>
                    <Option value="false">No</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name={["equipment", "winter_jackets"]}
                  label="Winter Jackets"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "Winter Jackets is Required",
                  //   },
                  // ]}
                >
                  <InputNumber placeholder="Winter Jackets" />
                </Form.Item>
              </div>
              {/* <div className="reSection">
                <Title level={5}>Referral</Title>
                <Form.Item name={"referral_person_name"}>
                  <Input placeholder="Referral person name" />
                </Form.Item>
                <Form.Item name={"referral_person_number"}>
                  <Input placeholder="Referral person number" />
                </Form.Item>
                <Form.Item name={"referral_person_bank_details"}>
                  <Input placeholder="Referral person bank details" />
                </Form.Item>
                <Form.Item name={"referral_person_bank_account"}>
                  <Input placeholder="Bank Account#" />
                </Form.Item>
              </div> */}
              {/* <div className="reSection">
                <Title level={5}>Address</Title> 
                <Form.Item name={"zone"}>
                  <Select
                    value={props.riderZoneId}
                    onChange={props.riderZoneChange}
                    placeholder="Select Zone"
                    style={{ width: "100%" }}
                  >
                    {props.postDataZone &&
                      props.postDataZone.map((zone) => (
                        <Select.Option key={zone._id} value={zone._id}>
                          {zone.zoneName}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item> 
              </div> */}
              {/* <div className="reSection">
                <Title level={5}>General</Title>
                <Form.Item name={"general_about_us"}>
                  <Input placeholder="How did you hear about us?" />
                </Form.Item>
                <Form.Item name={"general_cnic_issue_date"}>
                  <Input placeholder="CNIC issue date" />
                </Form.Item>
              </div> */}
            </Tabs.TabPane>
            <Tabs.TabPane tab="Verification" key="2">
              <Form.Item
                name={"cnicfront"}
                label="CNIC Front"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.cnicFront ? (
                    <img
                      src={props.riderData.cnicFront}
                      alt="CNIC Front"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                      />
                  ) : (
                    uploadFrontCNICButton
                  )}
                </Upload>
              </Form.Item>
              <Form.Item
                name={"cnicback"}
                label="CNIC Back"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.cnicBack ? (
                    <img
                      src={props.riderData.cnicBack}
                      alt="CNIC Back"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                    />
                  ) : (
                    uploadBackCNICButton
                  )}
                </Upload>
              </Form.Item>
              <Form.Item
                name={"licensefront"}
                label="License Front"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.licenseFront ? (
                    <img
                      src={props.riderData.licenseFront}
                      alt="License Front"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                    />
                  ) : (
                    uploadFrontLicenseButton
                  )}
                </Upload>
              </Form.Item>
              <Form.Item
                name={"licenseback"}
                label="License Back"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.licenseBack ? (
                    <img
                      src={props.riderData.licenseBack}
                      alt="License Back"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                    />
                  ) : (
                    uploadBackLicenseButton
                  )}
                </Upload>
              </Form.Item>
              {/* <Form.Item
                name={"profileimage"}
                label="Profile Image"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.profileImage ? (
                    <img
                      src={
                        "data:image/jpeg;base64," + props.riderData.profileImage
                      }
                      alt="Profile Image"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                    />
                  ) : (
                    uploadProfileImageButton
                  )}
                </Upload>
              </Form.Item> */}
              <Form.Item
                name={"billfront"}
                label="Bill"
                valuePropName="fileList"
                getValueFromEvent={normFile}
              >
                <Upload
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={true}
                  // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                  maxCount={1}
                >
                  {props.riderData.bill ? (
                    <img
                      src={props.riderData.bill}
                      alt="Bill Front"
                      style={{ width: "100%", "object-fit": "contain", "height": "100%" }}
                    />
                  ) : (
                    uploadFrontBillButton
                  )}
                </Upload>
              </Form.Item>
              {/* <Form.Item label="Status" name={"status"}>
                <Select>
                  <Option value="available">Active</Option>
                  <Option value="blocked">Blocked</Option>
                </Select>
              </Form.Item> */}
            </Tabs.TabPane>
          </Tabs>
          {/* <Form.Item
            wrapperCol={{
              span: 12,
              offset: 6,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item> */}
        </Form>
      )}
    </Modal>
  );
};

export default RiderEditModal;
